<template>
	<div v-if="user || this.$route.query.role === 'admin'" class="rightsidebar__partner-section">
		<h4 class="rightsidebar__partner-section-heading">Dla przedstawicieli</h4>
		<Remark />
		<button type="button" class="button--outlined" @click="showContractFormOverlay">
			Wygeneruj umowę
		</button>
		<button
			v-if="user"
			:class="{button: isDiscountInputShown, 'button--outlined': !isDiscountInputShown}"
			@click="toggleDiscountInput"
		>
			<template v-if="isDiscountInputShown">
				Zatwierdź rabat
			</template>
			<template v-else>
				Przyznaj rabat
			</template>
		</button>
		<button type="button" class="button--outlined" @click="showConfigurationFormOverlay">
			Wygeneruj ofertę
		</button>
		<label class="rightsidebar__partner-discount-label" v-if="isDiscountInputShown">
			<input
				@keypress="
					e => {
						e.keyCode === 13 && toggleDiscountInput();
					}
				"
				min="0.00"
				step="1"
				max="5.00"
				class="rightsidebar__partner-discount-input"
				type="number"
				v-model="discount"
			/>
		</label>
	</div>
</template>

<script>
import Remark from './Remark';

export default {
	name: 'RightSidebarPartnerSection',
	components: {Remark},
	data() {
		return {
			isDiscountInputShown: false,
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	created() {
		this.discount = parseFloat(this.$store.getters['unitConfiguration/discount'] * 100);
	},
	methods: {
		toggleDiscountInput() {
			if (this.isDiscountInputShown)
				this.$store.commit('unitConfiguration/setDiscount', this.discount / 100);

			this.isDiscountInputShown = !this.isDiscountInputShown;
		},
		showContractFormOverlay() {
			this.$store.commit('M_SET_APP_STATE', {
				isContractFormOverlayVisible: !this.$store.state.app.isContractFormOverlayVisible,
			});
		},
		showConfigurationFormOverlay() {
			this.$store.commit('M_SET_APP_STATE', {
				isConfigurationFormOverlayVisible: !this.$store.state.app.isConfigurationFormOverlayVisible,
			});
		},
	},
};
</script>

<style></style>
